export const minimumPriceCents = 100000;
export const maximumPriceCents = 1000000000;
